import {
  buildClaimCompanyProfileTermsConditionsURI,
  Section,
  useConfig,
} from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Box, Text, TextLink } from 'braid-design-system';
import { CompanyProfilesPage } from '../../../paths';
import { useIsSalariesPageFeatureOn } from '../../../shared/utils/useIsSalariesPageFeatureOn';
import translations from './.vocab';

export const SeoCtaBlurb = ({
  companyName,
  getCompanyProfilesPageUrl,
  onActiveTabChanged,
}: {
  companyName: string;
  getCompanyProfilesPageUrl: (p: CompanyProfilesPage) => string;
  onActiveTabChanged: (item: string | undefined) => void;
}) => {
  const { t } = useTranslations(translations);
  const config = useConfig();
  const isSalariesPageFeatureOn = useIsSalariesPageFeatureOn();
  return (
    <Section>
      <Text size="small">
        {t(
          'Find out more about working at companyProfileModelName. Read company reviews from real employees, explore salaries and life and culture and view all open jobs.',
          {
            companyProfileModelName: companyName,
            isSalariesPageFeatureOn: isSalariesPageFeatureOn ? 'true' : 'false',
            ReviewsPage: (children) => (
              <TextLink
                weight="weak"
                href={getCompanyProfilesPageUrl(CompanyProfilesPage.Reviews)}
                onClick={(e) => {
                  e.preventDefault();
                  onActiveTabChanged(CompanyProfilesPage.Reviews);
                }}
              >
                {children}
              </TextLink>
            ),
            CulturePage: (children) => (
              <TextLink
                weight="weak"
                href={getCompanyProfilesPageUrl(CompanyProfilesPage.Culture)}
                onClick={(e) => {
                  e.preventDefault();
                  onActiveTabChanged(CompanyProfilesPage.Culture);
                }}
              >
                {children}
              </TextLink>
            ),
            JobsPage: (children) => (
              <TextLink
                weight="weak"
                href={getCompanyProfilesPageUrl(CompanyProfilesPage.Jobs)}
                onClick={(e) => {
                  e.preventDefault();
                  onActiveTabChanged(CompanyProfilesPage.Jobs);
                }}
              >
                {children}
              </TextLink>
            ),
            SalariesPage: (children) => (
              <TextLink
                weight="weak"
                href={getCompanyProfilesPageUrl(CompanyProfilesPage.Salaries)}
                onClick={(e) => {
                  e.preventDefault();
                  onActiveTabChanged(CompanyProfilesPage.Salaries);
                }}
              >
                {children}
              </TextLink>
            ),
          },
        )}
      </Text>
      <Box marginTop="large">
        <Text size="small">
          {t('Profile Disclaimer', {
            TextLink: (children) => (
              <TextLink
                href={buildClaimCompanyProfileTermsConditionsURI({
                  environment: config.environment,
                  country: config.country,
                })}
                target="_blank"
                weight="weak"
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>
      </Box>
    </Section>
  );
};
